import Select from "../Select";

type CardProps = {
  className?: string;
  classHead?: string;
  title?: string;
  children: React.ReactNode;
  stretch?: boolean;
  selectOptions?: { id: number; name: string }[];
  selectValue?: {
    id: number;
    name: string;
  };
  selectOnChange?: (value: { id: number; name: string }) => void;
  headContent?: React.ReactNode;
};

const Card = ({
  className,
  classHead,
  title,
  stretch,
  selectOptions,
  selectValue,
  selectOnChange,
  children,
  headContent,
}: CardProps) => {
  const hasHead = (title || headContent || selectOptions || selectValue)

  return (
    <div className={`card flex flex-col ${className || ""}`}>
      {
        hasHead &&
        <div
          className={`flex min-w-0 items-center h-12 shrink-0 pl-5 max-lg:pl-3 ${classHead || ""
            }`}
        >
          {title && <div className="shrink-0 text-h6">{title}</div>}
          {headContent ? (
            <div className="flex min-h-0 min-w-0 flex-1 items-center">
              {headContent}
            </div>
          ) : (
            <div className="flex-1" />
          )}
          {selectOptions && selectValue && selectOnChange && (
            <Select
              className="ml-auto min-w-40 max-md:min-w-34"
              value={selectValue}
              onChange={selectOnChange}
              options={selectOptions}
            />
          )}
        </div>
      }
      <div className={`flex flex-col ${hasHead ? "pt-3" : ""} ${stretch ? "grow" : ""}`}>{children}</div>
    </div>
  )
};

export default Card;
